import { CultureInfo } from '../culture-info.model';
import { CultureInfoFr } from './fr';

/**
 * @ignore
 */
export const CultureInfoFrTG: CultureInfo = {
  name: 'fr-TG',
  displayName: 'français (Togo)',
  iso3LanguageCode: 'fra',
  iso2LanguageCode: 'fr',
  ietfLanguageTag: 'fr-TG',
  parent: CultureInfoFr
};
